import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDateString = (dateTimeString: string) => {
	const dayjsDateTime = dayjs(dateTimeString);
	const dateWithoutTime = dayjsDateTime.startOf("day");
	return dateWithoutTime.format("YYYY-MM-DD");
};

export const extractYearFromDate = (dateString: string) => {
	const dayjsDate = dayjs(dateString);
	return dayjsDate.year();
};

export const dateFormatter = (date: Date, format: string): string => {
	const formattedDate = dayjs(date).isValid()
		? dayjs(date).format(format)
		: dayjs().format(format);

	return formattedDate;
};

export function tableDateFormatter(text: string | null, format: string) {
	if (!text) {
		return "";
	}
	const localDate = dayjs.utc(text).tz(dayjs.tz.guess());
	const formattedDate = localDate.isValid()
		? localDate.format(format)
		: dayjs().format(format);
	return formattedDate;
}